module.exports = function() {
  return new Worker(__webpack_public_path__ + "151dcd4ecc37bb23e38b.worker.js");
};